import { render } from "./RecipientsStaffTable.vue?vue&type=template&id=1fb8aede&scoped=true"
import script from "./RecipientsStaffTable.vue?vue&type=script&lang=js"
export * from "./RecipientsStaffTable.vue?vue&type=script&lang=js"

import "./RecipientsStaffTable.vue?vue&type=style&index=0&id=1fb8aede&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb8aede"]])

export default __exports__